import React, { ReactNode } from 'react';

export interface StepHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Small mono label above the title, e.g. "STEP 1 OF 4" or a section number. */
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
}

/**
 * One heading treatment for every step of a multi-step flow, so a stepped
 * form reads as a single designed experience instead of each step inventing
 * its own title style. See `.step-head` in global.css.
 */
export const StepHeader: React.FC<StepHeaderProps> = ({
  eyebrow,
  title,
  description,
  className = '',
  ...props
}) => (
  <div className={`step-head ${className}`.trim()} {...props}>
    {eyebrow && <div className="step-eyebrow">{eyebrow}</div>}
    <h2>{title}</h2>
    {description && <p>{description}</p>}
  </div>
);
